import { IconSpeakerphone } from "@tabler/icons-react";

import styles from "~/components/layout/AnnouncementBanner.module.css";
import { useFeatureFlags } from "~/contexts/featureFlagProvider";
import { announcementBannerText } from "~/shared/constants/feature-flag.constants";
import { Alert, Anchor } from "~/ui";

const URL_REGEX = /(https?:\/\/[^\s]+)/g;

/** Splits text on URLs and renders each URL as a clickable link. */
const TextWithLinks = ({ text }: { text: string }): JSX.Element => {
  const parts = text.split(URL_REGEX);
  return (
    <>
      {parts.map((part, i) =>
        URL_REGEX.test(part) ? (
          <Anchor key={i} href={part} target="_blank" rel="noopener noreferrer" fw={600}>
            {part}
          </Anchor>
        ) : (
          <span key={i}>{part}</span>
        ),
      )}
    </>
  );
};

export const AnnouncementBanner = (): JSX.Element | null => {
  const { getFeatureFlagString } = useFeatureFlags();

  const bannerText = getFeatureFlagString(announcementBannerText);

  if (!bannerText) {
    return null;
  }

  return (
    <Alert
      icon={<IconSpeakerphone size={18} />}
      color="yellow"
      variant="light"
      radius={0}
      role="status"
      className={styles.banner}
      wrapperClassName={styles.bannerWrapper}
      bodyClassName={styles.bannerBody}
    >
      <TextWithLinks text={bannerText} />
    </Alert>
  );
};
